import script from "./IncomeStatementSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeStatementSummary.vue?vue&type=script&setup=true&lang=js"

import "./IncomeStatementSummary.vue?vue&type=style&index=0&id=32b1e05c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b1e05c"]])

export default __exports__